import { LocationStrategy } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { GoogleAnalyticsService } from './core/providers/google-analytics/google-analytics.service';
import { LayoutService } from './core/providers/layout/layout.service';
import { TokenService } from './core/providers/token/token.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterModule],
})
export class AppComponent implements OnInit, OnDestroy {
  private layoutService = inject(LayoutService);
  private cdr = inject(ChangeDetectorRef);
  private googleAnalyticsService = inject(GoogleAnalyticsService);
  private tokenService = inject(TokenService);
  private locationStrategy = inject(LocationStrategy);

  isLoaded = false;
  isLogoLoaded = false;
  private subscriptions: Subscription = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this.layoutService.loadedLayoutData$.subscribe(isLoaded => {
        this.isLoaded = isLoaded;
        this.cdr.detectChanges();
      })
    );
    this.subscriptions.add(
      this.layoutService.loadedLogo$.subscribe(isLoaded => {
        this.isLogoLoaded = isLoaded;
        this.cdr.detectChanges();
      })
    );
    this.subscriptions.add(
      this.tokenService.getToken$().subscribe(token => {
        if (token) {
          this.googleAnalyticsService.injectGAScript(token);
        }
      })
    );
    this.preventBackButton();
  }

  preventBackButton(): void {
    history.pushState(null, '', window.location.href);
    this.locationStrategy.onPopState(() => {
      window.history.go(-1);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
